import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { IItemProdutoRetirada } from '../../../item-produto-retirada/item-produto-retirada.model';
import { IItemInventarioRetirada } from '../../model/item-inventario-retirada.interface';
import { IInventarioLotePK } from '../../model/inventarioLotePk.interface';

import * as $ from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class TabelaInventarioService {

  constructor() { }

  limpar(): void {
    this.limparCheckbox();
    this.limparAMover();
  }

  /**
   * =======================================
   * BEGIN checkbox functions
   * =======================================
   */
  limparCheckbox(): void {
    $("input[name=checkboxLote]").each(function(){
      $(this).prop("checked", false);
    });
  }

  isChecked(idInventario: number, idLote: number): boolean {
    return $(`#checkbox_lote_${idInventario}_${idLote}`).prop('checked');
  }

  clickCheckbox(idInventario: number, idLote: number): void {
    $(`#checkbox_lote_${idInventario}_${idLote}`).trigger('click');
  }

  desmarcarCheckbox(idInventario: number, idLote: number): void {
    if ( this.isChecked(idInventario, idLote) ) {
      this.clickCheckbox(idInventario, idLote);
    }
  }

  selecionarCheckbox(idInventario: number, idLote: number): void {
    if ( !this.isChecked(idInventario, idLote) ) {
      this.clickCheckbox(idInventario, idLote);
    }
  }

  atualizarCheckboxPeloValorAMover(event: any): void {
    if ( event ) {
      const pk: IInventarioLotePK = this.getInventarioELotePKFromInputAMover($(event.target));
      if ( pk ) {
        if ( Number.isNaN($(event.target).val()) ) {
          this.desmarcarCheckbox(pk.idInventario, pk.idLote);
        }
        else {
          this.selecionarCheckbox(pk.idInventario, pk.idLote);
        }
      }
    }
  }
    /**
   * =======================================
   * // END checkbox functions
   * =======================================
   */





  /**
   * =======================================
   * BEGIN input field mover functions
   * =======================================
   */
  limparAMover(): void {
    $("input[name=input_mover]").each(function(){
      $(this).val('');
    });
  }

  getValorAMoverDoInput(idInventario: number, idLote: number): number {
    const $input = $(`#input_mover_${idInventario}_${idLote}`);
    if ( $input.val() ) {
      return parseInt($input.val(), 0);
    }

    return 0;
  }

  setValorAMoverNoInput(idInventario: number, idLote: number, quantidade: number): void {
    const $input = $(`#input_mover_${idInventario}_${idLote}`);
    $input.val(quantidade);
  }

  atualizarValorAMover(idInventario: number, 
                       idLote: number, 
                       iiQuantidadeOriginal: number,
                       quantidadeAMoverSubject: Subject<number>,
                       quantidadeSolicitada: number) {

    if ( this.isChecked(idInventario, idLote) ) {
      const $input = $(`#input_mover_${idInventario}_${idLote}`);

      // parse to number
      iiQuantidadeOriginal = +iiQuantidadeOriginal;
      quantidadeSolicitada = +quantidadeSolicitada;

      const quantidadeSelecionada = this.getTotalAMover();
      let quantidadeASolicitar = iiQuantidadeOriginal;

      // ao clicar no checkbox, ao inves de colocar o valor itemInventario.quantidade
      // diretamente no input quantidadeAMover, verificar se a quantidade total nao vai extrapolar
      // a quantidade solicitada.
      // SE FOR extrapolar, adicionar somente a quantidade necessária.
      if ( (iiQuantidadeOriginal + quantidadeSelecionada) > quantidadeSolicitada ) {
        quantidadeASolicitar = ( quantidadeSolicitada - quantidadeSelecionada );
      }

      if ( !$input.val() ) {
        $input.val(quantidadeASolicitar);
        $input.focus();
        $input.select();
      }
    }
    else {
      const input = $(`#input_mover_${idInventario}_${idLote}`);
      input.val('');
    }

    const quantidadeAMover = this.getTotalAMover();
    quantidadeAMoverSubject.next(quantidadeAMover);

    return quantidadeAMover;
  }

  // TODO check
  getInventarioELotePKFromInputAMover($input): IInventarioLotePK {
    const id = $input.attr('id').split('input_mover_')[1];
    const idInventario = Number.parseInt(id.split('_')[0]);
    const idLote = Number.parseInt(id.split('_')[1]);

    return {
      idInventario: idInventario,
      idLote: idLote
    };
  }

  getQuantidadeHidden(idInventario: number, idLote: number) {
    if ( !idInventario || !idLote ) {
      return 0;
    }

    return $(`#hidden_quantidade_${idInventario}_${idLote}`).val();
  }

  getTotalAMover(event?: any): number {
    let acumulado = 0;
    const inputs = document.getElementsByName('input_mover');
    for (let i = 0; i < inputs.length; i++) {
      const $input = $(inputs[i]);

      const pk: IInventarioLotePK = this.getInventarioELotePKFromInputAMover($input);

      if ( this.isChecked(pk.idInventario, pk.idLote) ) {
        const valor = Number.parseInt($input.val()) | 0;
        acumulado += valor;
      }
    }

    // selecionar o checkbox se o usuário digitar o valor no input
    this.atualizarCheckboxPeloValorAMover(event);

    return acumulado;
  }


  /**
   * =======================================
   * END input field mover functions
   * =======================================
   */






  /**
   * deve carregar esta tabela de detalhes com valores da tabela principal ( que invocou )
   */
  preCarregarTabela(dadosTabela: IItemProdutoRetirada[]): void {
    for ( let item of dadosTabela ) {
      if ( item.inventario && item.lote ) {
        const idInventario = item.inventario.id;
        const idLote = item.lote.id;

        this.selecionarCheckbox(idInventario, idLote);
        this.setValorAMoverNoInput(idInventario, idLote, item.quantidade);
      }
    }
  }


 getItensSelecionados(): IItemInventarioRetirada[] {
  const iirSelecionados: IItemInventarioRetirada[] = [];
  $("input:checked[name=checkboxLote]").each(function(index, element) {
    const o = JSON.parse(element.value);
    if ( o.quantidadeRetirada > 0 ) {
      iirSelecionados.push(JSON.parse(element.value));  
    }
  });

  return iirSelecionados;
}  

}
